<app-alert-status *ngIf="alert" [alert]="alert" [parent]="componentName" (emitAlertCancelled)="alert = $event"></app-alert-status>
<div class="row justify-content-start">
    <div class="col-md-2">
      <app-section-nav [navItems]="usersDetailNavItems"></app-section-nav>
    </div>
    <div class="col-md-10">
      <app-dynamic-form *ngIf="currentScope == 'basics'" [data]="currentUser" [blocks]="usersDetailBasicsBlocks" (dataUpdate)="dataUpdate($event)"></app-dynamic-form>
      <app-popup-modal *ngIf="modalInfo" [modalInfo]="modalInfo" (action)="closeModal($event)"></app-popup-modal>        
    </div>
</div>